import { render, staticRenderFns } from "./leaderBoard.vue?vue&type=template&id=20b7169b&scoped=true&"
import script from "./leaderBoard.vue?vue&type=script&lang=js&"
export * from "./leaderBoard.vue?vue&type=script&lang=js&"
import style0 from "./leaderBoard.vue?vue&type=style&index=0&id=20b7169b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b7169b",
  null
  
)

export default component.exports